import api from "@services/apiList";
import { ResponseType } from "../../../Types/ServicesType/servicesType";
import { MasterDataType, MasterTableDataType, SaveResponseType, SearchParamsType, UploadedListType } from "./types";
import { getConstants } from "@utilifiles/methods/storage/storage";
import instance from "@services/services";
const { clinicId, createdById } = getConstants()
const {MastersApi} = api
export const getMastersTableData = async (params:SearchParamsType):Promise<ResponseType<{icdList:MasterTableDataType[],totalRecords:number}>>=>{
    const result = await instance.post(`${MastersApi.getIcdTableData}`,{...params,clinicId});
    return result.data;
}

export const saveMasterData = async (params:MasterDataType[]):Promise<ResponseType<SaveResponseType>>=>{
    const result = await instance.post(`${MastersApi.saveIcdMasterData}`,params);
    return result.data;
}

export const uploadFile = async (file:File):Promise<ResponseType<string>>=>{
    const formData = new FormData();
    formData.append("clinicId", `${clinicId}`);
    formData.append("createdById", `${createdById}`);
    formData.append("file", file);
    const result = await instance.post(`${MastersApi.uploadIcdFile}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
    return result.data;
}

export const getUploadedData = async (params:SearchParamsType):Promise<ResponseType<{icdUploadData:UploadedListType[],totalRecords:number}>>=>{
    const result = await instance.post(`${MastersApi.getIcdUploadedData}`,params);
    return result.data;
}

export const importAlldata = async ():Promise<ResponseType<string>>=>{
    const formData = new FormData()
    formData.append("clinicId", `${clinicId}`);
    formData.append("createdById", `${createdById}`);
    const result = await instance.get(`${MastersApi.importAllIcdData}/${clinicId}?createdById=${createdById}`);
    return result.data;
}

export const clearAllImportedData = async ():Promise<ResponseType<string>>=>{
    const result = await instance.get(`${MastersApi.clearAllIcdImportedData}`);
    return result.data;
}
